import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-checkbox-element',
  templateUrl: './checkbox-element.component.html',
  styleUrls: ['./checkbox-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckboxElementComponent {
  @Input() value: boolean
  @Input() indeterminate = false
  @Input() extraClass = ''
  @Input() extraLabelClass = ''
  @Input() extraCheckboxClass = ''
  @Input() label: string
  @Input() mobileLabel: string
  @Input() disabled = false
  @Input() size = 18

  @Output() changed = new EventEmitter<boolean>()
}
